import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard, HoverIcon } from "../components/HoverMotion";
import { FaLaptopCode, FaBolt, FaShieldAlt } from "react-icons/fa";

const cardVariants = {
  hidden: { opacity: 0, y: 25, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.12, delayChildren: 0.2 } },
};

export const SectionWhoWeAre = () => {
  const features = [
    {
      id: 1,
      icon: <FaLaptopCode className="w-5 h-5" />,
      title: "Modern Technology",
      description:
        "GPS telemetry, live tracking maps, chip timing, and AI photo recognition — built on real-time databases that keep every position, split, and result accurate as the race unfolds.",
    },
    {
      id: 2,
      icon: <FaBolt className="w-5 h-5" />,
      title: "Fast & Responsive",
      description:
        "Positions and results update live during the event — spectators follow their athletes, organizers monitor the course, and safety teams spot who needs help, all without delay.",
    },
    {
      id: 3,
      icon: <FaShieldAlt className="w-5 h-5" />,
      title: "Trusted Partner",
      description:
        "Relied upon by trail, endurance, and large-scale event organizers across Indonesia and the region to run their operations smoothly.",
    },
  ];

  return (
    <section id="who-we-are" className="w-full py-16 lg:py-24 px-4 bg-slate-50 overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            variants={cardVariants}
          >
            Who We Are
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            variants={cardVariants}
          >
            VIONIXASIA is a digital technology company specializing in end-to-end solutions for sports events and large-scale gatherings. We combine data-driven platforms with hands-on expertise to deliver seamless experiences for organizers and participants alike.
          </motion.p>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          variants={containerVariants}
        >
          {features.map((feature, index) => (
            <motion.div
              key={feature.id}
              variants={cardVariants}
            >
              <HoverCard className={`p-4 h-full flex items-start gap-4 rounded-card border border-slate-200 ${index === 1 ? "bg-slate-900" : "bg-white"}`}>
                <HoverIcon className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-icon border ${index === 1 ? "bg-white/10 border-white/20 text-white" : "bg-slate-100 border-slate-200 text-slate-700"}`}>
                  {feature.icon}
                </HoverIcon>
                <div className="flex-1">
                  <h3 className={`text-lg font-bold mb-1 ${index === 1 ? "text-white" : "text-slate-900"}`}>
                    {feature.title}
                  </h3>
                  <p className={`text-sm leading-relaxed ${index === 1 ? "text-slate-300" : "text-slate-600"}`}>
                    {feature.description}
                  </p>
                </div>
              </HoverCard>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};
